/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Disconnect_PlannedInputs */



/**
* | output |
* | --- |
* | "Planned conversations without a report disappear from your overview." |
*
* @param {Connections_Disconnect_PlannedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_disconnect_planned = /** @type {((inputs?: Connections_Disconnect_PlannedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Disconnect_PlannedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geplande gesprekken zonder verslag verdwijnen uit je overzicht.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les conversations prévues sans compte rendu disparaissent de votre aperçu.")
	return /** @type {LocalizedString} */ ("Planned conversations without a report disappear from your overview.")
});